import React from 'react';
import PropTypes from 'prop-types';

import IString from '../../common/components/i-string';
import { serverToQueryString } from '../../common/util/server-util';
import { EMAIL_CODE_EXPIRED, EMAIL_CODE_INVALID } from '../constants/errors';

const keys = {
  [EMAIL_CODE_EXPIRED]: 'expired',
  [EMAIL_CODE_INVALID]: 'invalid'
};

function VerificationFailure(props) {
  const { errorType } = props;

  const query = serverToQueryString();
  const key = keys[errorType] || keys[EMAIL_CODE_INVALID];

  return (
    <>
      <h2 className='formTitle'>
        <IString stringKey={`${key}.title`} />
      </h2>
      <div className='formish'>
        <p>
          <IString stringKey={`${key}.message`} />
        </p>
        <p>
          <IString stringKey={`${key}.remedy`} />
        </p>

        <div className='actions'>
          <a href={`/login${query}`} className='button default'>
            <IString stringKey={`${key}.login`} />
          </a>
        </div>
      </div>
    </>
  );
}

VerificationFailure.propTypes = {
  errorType: PropTypes.oneOf(Object.keys(keys))
};

export default VerificationFailure;
